import axios from 'axios'

export default {
  upload (data) {
    const formData = new FormData()
    formData.append('File1', data)
    return axios({
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      url: process.env.VUE_APP_API_PATH + 'api/Upload3/bookUpload.asp',
      data: formData
    })
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}

